// extracted by mini-css-extract-plugin
export var change = "_43-1";
export var changeList = "_43-0";
export var changePath = "_43-2";
export var diffArrow = "_43-5";
export var diffRow = "_43-3";
export var diffValue = "_43-4";
export var error = "_43-8";
export var notice = "_43-9";
export var result = "_43-6";
export var success = "_43-7";